import React, { type ReactElement } from 'react';

import { PrimaryButton, ProButton } from '@components/Button/variants';
import { Theme } from '@interfaces/global';

import OfferOption, { SelectedOffer } from '../OfferOption';
import { Offer } from '../OfferOption';

interface PaywallFullBleedTwoOptionProps {
  buttonText: string;
  handleButtonClick: () => void;
  handleOptionSelection: (offer: SelectedOffer) => void;
  paywallLeadOffers: Offer[];
  selectedOption: SelectedOffer;
}

const PaywallFullBleedTwoOption = ({
  buttonText,
  handleButtonClick,
  handleOptionSelection,
  paywallLeadOffers,
  selectedOption,
}: PaywallFullBleedTwoOptionProps): ReactElement => {
  const Button = selectedOption?.isPro ? ProButton : PrimaryButton;

  return (
    <div className="mb-80 flex flex-col gap-16 sm:flex-row sm:items-center md:flex-col md:items-start">
      <div className="mt-16 flex w-full flex-col items-center justify-start gap-16 *:w-full *:max-w-none sm:flex-row sm:items-start md:*:flex-col lg:mt-24">
        {!!selectedOption &&
          paywallLeadOffers?.map((offer, index) => (
            <OfferOption
              contentContainerClassName="flex justify-between *:has-[p]:w-1/2 *:has-[p]:mt-0 *:has-[p]:shrink-0 sm:*:has-[p]:mt-4 w-full sm:flex-col sm:*:has-[p]:w-full md:mt-4"
              key={index}
              offer={offer}
              selectedOfferCode={selectedOption.code}
              setSelectedOffer={handleOptionSelection}
              theme={Theme.Light}
            />
          ))}
      </div>
      <Button
        as="button"
        size="small"
        disabled={!selectedOption}
        onClick={handleButtonClick}
        className="mx-auto w-full max-w-[343px] cursor-pointer touch-manipulation sm:mx-0 md:max-w-[185px]"
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default PaywallFullBleedTwoOption;
